import { useState } from "react";
import * as XLSX from "xlsx";
import { useBulkHistory } from "../../../hook/useBookHistory";
import { useUsersByIds } from "../../../hook/useUsersByIds";
import { SelectOption } from "../../../ui/Select/selectType";

export function useContentHome() {
    const [filters, setFilters] = useState({
        action: undefined as string | undefined,
        action_type: undefined as string | undefined,
        requester: undefined as string | undefined,
        startDate: undefined as Date | undefined,
        endDate: undefined as Date | undefined
    });

    const { data: records = [], isLoading } = useBulkHistory(filters);
    const requesterIds = Array.from(
        new Set(
            records
                .map(r => Number(r.custom_object_fields.requester))
                .filter(Boolean)
        )
    );
    const { data: users = [] } = useUsersByIds(requesterIds);

    const usersMap = users.reduce<Record<number, string>>((acc, u) => {
        acc[u.id] = u.name;
        return acc;
    }, {});

    const requesterOptions: SelectOption[] = users.map(u => ({
        label: u.name,
        value: String(u.id)
    }));


    const optionsAction: SelectOption[] = [
        { label: "Criação massiva", value: "create" },
        { label: "Edição massiva", value: "update" }
    ];

    const optionsActionType: SelectOption[] = [
        { label: "Ticket", value: "ticket" },
        { label: "Organização", value: "organization" },
        { label: "Usuário", value: "user" }
    ];

    const clearFilters = () => {
        setFilters({
            action: undefined,
            action_type: undefined,
            requester: undefined,
            startDate: undefined,
            endDate: undefined
        });
    };


    const handleDownloadReport = () => {
        if (!records.length) return;

        const data = records.map(r => ({
            Usuário:
                usersMap[Number(r.custom_object_fields.requester)] ?? "-",

            Ação:
                r.custom_object_fields.action === "create"
                    ? "Criação massiva"
                    : "Edição massiva",

            Tipo:
                r.custom_object_fields.action_type === "ticket"
                    ? "Ticket"
                    : r.custom_object_fields.action_type === "user"
                        ? "Usuário"
                        : "Organização",

            Quantidade: r.custom_object_fields.success_count,

            Data: new Date(r.updated_at).toLocaleString("pt-BR"),

        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Histórico");

        const fileName = `historico_bulk_ops_${new Date()
            .toISOString()
            .split("T")[0]}.xlsx`;

        XLSX.writeFile(workbook, fileName);
    };

    return{
        records,
        isLoading,
        optionsAction,
        optionsActionType,
        requesterOptions,
        setFilters,
        filters,
        clearFilters,
        usersMap,
        handleDownloadReport
    }
}